<div class="field-label-row">
  <label for="sms_body">
    {{ newFeed.enabled ? 'Notification Text' : 'Message' }}
  </label>
  <div class="dynamic-field-select-group">
    <p style="color: grey">Insert dynamic field:</p>
    <mat-select
      class="dynamic-field-select"
      panelClass="sms-builder-dynamic-field-select-panel"
      [panelWidth]="null"
      [value]="bodyFieldSelectValue"
      [placeholder]="dynamicInputsPlaceholder"
      (selectionChange)="onBodyFieldSelected($event.value)"
      (closed)="restorePendingFocus()"
      >
      @for (field of dynamicInputs; track field) {
        <mat-option [value]="field">{{ field }}</mat-option>
      }
    </mat-select>
  </div>
</div>
<rn-form-input-state-control
  [formReference]="smsFormGroup.controls['sms_body']"
  [showCharacterCount]="false"
  >
  <ng-container>
    <textarea
      #smsBodyTextarea
      [formControl]="smsFormGroup.controls['sms_body']"
      [mentionConfig]="mentionConfig"
      [mention]="dynamicInputs"
      [placeholder]="bodyPlaceholder"
      class="form-control sms_body"
      id="sms_body"
      mentionInput
      name="sms_body"
      rows="3"
      dir="auto"
      (blur)="captureBodySelection($event)"
    ></textarea>
  </ng-container>
</rn-form-input-state-control>

@if (showDestination) {
  <div class="link-selector">
    <label for="sms_auth_link">Destination</label>
    <div>
      @if (isTwoWaySms) {
        <div class="link-dropdown link-dropdown--text-only">
          Two Way Conversation
        </div>
      }
      <div class="d-flex justify-content-between">
        @if (!isTwoWaySms) {
        <mat-form-field appearance="outline" class="destination-select-field">
          <mat-select panelClass="sms-builder-destination-select-panel" [panelWidth]="200" [formControl]="selectedLinkType"
            id="destination-select">
            @for (linkType of this.linkTypes; track linkType) {
            <mat-option [value]="linkType.value" [attr.data-testid]="'destination-select-option-' + linkType.value">
              {{ linkType.display_text }}
            </mat-option>
            }
          </mat-select>
        </mat-form-field>
        }

        <!-- readonly input for both none & message details link types -->
        @if (showReadOnlyIntro()) {
          <input
            [formControl]="smsFormGroup.controls['auth_link']"
            class="form-control sms-intro"
            name="sms_auth_link"
            readonly
            type="text"
            />
        }

        <!-- editable input for url link type -->
        @if (!showReadOnlyIntro()) {
          <input
            [formControl]="smsFormGroup.controls['auth_link']"
            [mentionConfig]="mentionConfig"
            [mention]="dynamicInputs"
            class="form-control sms-intro"
            mentionInput
            name="sms_auth_link"
            type="text"
            />
          <app-error-display [control]="smsFormGroup.controls['auth_link']"></app-error-display>
        }
      </div>
    </div>
  </div>
}

<div>
  <div class="field-label-row">
    <label for="sms_disclaimer">Disclaimer</label>
    <div class="dynamic-field-select-group">
      <p style="color: grey">Insert dynamic field:</p>
      <mat-select
        class="dynamic-field-select"
        panelClass="sms-builder-dynamic-field-select-panel"
        [panelWidth]="null"
        [value]="disclaimerFieldSelectValue"
        [placeholder]="dynamicInputsPlaceholder"
        (selectionChange)="onDisclaimerFieldSelected($event.value)"
        (closed)="restorePendingFocus()"
        >
        @for (field of dynamicInputs; track field) {
          <mat-option [value]="field">{{ field }}</mat-option>
        }
      </mat-select>
    </div>
  </div>
  <input
    #smsDisclaimerInput
    [formControl]="smsFormGroup.controls['sms_disclaimer']"
    [mentionConfig]="mentionConfig"
    [mention]="dynamicInputs"
    [placeholder]="disclaimerPlaceholder"
    class="form-control sms-disclaimer"
    id="sms_disclaimer"
    name="sms_disclaimer"
    type="text"
    dir="auto"
    (blur)="captureDisclaimerSelection($event)"
    />
  <app-error-display [control]="smsFormGroup.controls['sms_disclaimer']"></app-error-display>
</div>
<div>
  <div style="text-align: right">
    <div
      id="sms-character-counter"
      [ngClass]="{ 'warning-text': smsCharacterCount() > 160 }"
      >
      <b>{{ smsCharacterCount() }}</b> total characters
    </div>
  </div>
  <div style="text-align: right">
    <div
      id="sms-character-carrier-info"
      [ngClass]="{ 'warning-text': smsCharacterCount() > 160 }"
      >
      Beyond 160 characters, carrier may send multiple
      {{ newFeed.enabled ? 'notifications' : 'messages' }}
    </div>
  </div>
</div>
<br />

<div
  [ngClass]="{
    'alternate-message': true
  }"
  >
  <app-radio-btn
    [(btnModel)]="smsModel.is_alternate_message"
    [btnLabel]="
      newFeed.enabled ? 'Alternate Notification Text' : 'Alternate SMS Text'
    "
    [btnName]="'has-alternate-sms'"
    [btnWidth]="'100%'"
    [btnDisplayTrueFirst]="true"
    (btnModelChange)="toggleAlternateSMS()"
  ></app-radio-btn>

  <!-- textarea -->
  @if (smsModel.is_alternate_message) {
    <textarea
      [formControl]="smsFormGroup.controls['alternate_sms_text']"
      [mentionConfig]="mentionConfig"
      [mention]="alternateInputs"
      [placeholder]="alternateTextPlaceholder"
      class="form-control"
      mentionInput
      dir="auto"
      name="alt-sms"
    ></textarea>
    <app-error-display [control]="smsFormGroup.controls['alternate_sms_text']"></app-error-display>
    <p>include {{ '@{auth-link}' }} and any disclaimer</p>
    <div style="text-align: right">
      <div
        id="alternate-sms-character-counter"
        [ngClass]="{ 'warning-text': alternateSMSCharacterCount() > 160 }"
        >
        <b>{{ alternateSMSCharacterCount() }}</b> total characters
      </div>
    </div>
    <div style="text-align: right">
      <div
        id="alternate-sms-character-carrier-info"
        [ngClass]="{ 'warning-text': alternateSMSCharacterCount() > 160 }"
        >
        Beyond 160 characters, carrier may send multiple
        {{ newFeed.enabled ? 'notifications' : 'messages' }}
      </div>
    </div>
  }
</div>
<br />
